import styled from '@emotion/styled'
import { DollarCircleOutlined, FolderAddOutlined } from '@ant-design/icons'
import { useFormikContext } from 'formik'
import { JOIN_TYPE_OPTIONS } from '@sportninja/common/features/competition/wizard'
import type { WizardFormValues } from '@sportninja/common/features/competition/wizard'
import ChoiceCard from '../components/ChoiceCard'
import Text from 'src/components/ts-components/Text'
import colors from '@sportninja/common/constants/appColors'

const JOIN_ICONS = {
  registration: <DollarCircleOutlined style={{ fontSize: 40 }} />,
  manual: <FolderAddOutlined style={{ fontSize: 40 }} />,
} as const

const Step5Join = () => {
  const { values, setFieldValue } = useFormikContext<WizardFormValues>()
  return (
    <Container>
      <Header>
        <Text variant='heading3' weight='semiBold' color={colors.WHITE}>
          How Should Teams and Players Join?
        </Text>
        <Text variant='paragraphMedium' color={colors.NEUTRAL_50}>
          Choose how you want to add teams and players.
        </Text>
      </Header>
      <Grid>
        {JOIN_TYPE_OPTIONS.map((opt) => (
          <ChoiceCard
            key={opt.value}
            icon={JOIN_ICONS[opt.value]}
            title={opt.label}
            description={opt.description}
            selected={values.joinType === opt.value}
            onClick={() => setFieldValue('joinType', opt.value)}
            testId={`choice-join-${opt.value}`}
          />
        ))}
      </Grid>
    </Container>
  )
}

export default Step5Join

// ---- styled ----
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
  max-width: 720px;

  & > button {
    height: 255px;
  }
`
